module.exports = __webpack_public_path__ + "img/ctrl-rz-theta-stub-1.3cd9e342.svg";